export default {
  _not_interested_in_this_video: '當前視頻不感興趣嗎？ %second%',
  _switch_one: '換一個',
}